module.exports = __webpack_public_path__ + "static/meta-preview-939ca0855f54e610c8796d76efeeeedb.png";